var map = {
	"./EOS.png": "706e",
	"./OAN.png": "5bfc",
	"./XRP.png": "ba3f",
	"./acala.png": "4884",
	"./algorand.png": "b237",
	"./anchor.png": "b689",
	"./astar.png": "a845",
	"./bitcoin-cash.png": "f9e4",
	"./bitcoin-lightning.png": "303d",
	"./bitcoin.png": "e392",
	"./cardano.png": "051e",
	"./celo.png": "7ba2",
	"./cosmos.png": "1617",
	"./dash.png": "8b0b",
	"./dfinity.png": "65d9",
	"./diem.png": "4f34",
	"./dogecoin.png": "d1cf",
	"./ethereum-2.0.png": "5a7d",
	"./ethereum-classic.png": "0e06",
	"./ethereum.png": "88e9",
	"./filecoin.png": "339c",
	"./flow.png": "ce8b",
	"./goChain.png": "e776",
	"./graph.png": "9da7",
	"./harmony.png": "1727",
	"./helium.png": "b711",
	"./hyperledger.png": "c626",
	"./keep.png": "5571",
	"./kusama.png": "b9e2",
	"./litecoin.png": "ae15",
	"./livepeer.png": "b97f",
	"./mina.png": "4064",
	"./mobileCoin.png": "3f43",
	"./moonbeam.png": "4107",
	"./near.png": "21fb",
	"./nuCypher.png": "c9ca",
	"./oasis.png": "9a80",
	"./osmosis.png": "3eab",
	"./parity-ethereum.png": "eb91",
	"./parity-substrate.png": "f1a4",
	"./polkadot.png": "16af",
	"./provenance.png": "84e0",
	"./quorum.png": "6a68",
	"./serum.png": "b6ec",
	"./skale.png": "37f1",
	"./solana.png": "d3a6",
	"./stacks.png": "3156",
	"./stellar.png": "cf84",
	"./terra.png": "e100",
	"./tezos.png": "5d10",
	"./trust-wallet.png": "9784",
	"./zcash.png": "0322"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7ee7";